module.exports = __webpack_public_path__ + "img/share_log.64f529e4.svg";